import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { EllipsisOutlined } from '@ant-design/icons';

import { Dropdown, Menu, Modal } from 'antd';
import { colors, fixedSpacing } from '../../lib/theme';
import { deleteReviewComment } from '../../actions';

const { confirm } = Modal;

class ReviewReplyOptions extends Component {

    editReviewComment = () => {
        this.props.editReviewCommentParent();
        // this.props.editReviewComment(review, commentId, replyComment, userDetails);
    }

    deleteReviewCommentFn = () => {
        const { review, userDetails, commentId, deleteReviewComment } = this.props;
        confirm({
            title: 'Are you sure you want to delete this review?',
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                deleteReviewComment(review, commentId, userDetails);
            },
            onCancel() {
                //   console.log('Cancel');
            },
        });
    }

    render() {
        const { userDetails } = this.props;

        const menu = (
            <Menu>
                <Menu.Item key="editComment">
                    <a onClick={this.editReviewComment}>Edit</a>
                </Menu.Item>
                <Menu.Item key="deleteComment">
                    <a onClick={this.deleteReviewCommentFn}>Delete</a>
                </Menu.Item>
            </Menu>
        );


        return (
            <div style={{ position: 'absolute', right: '0' }}>
                {
                    userDetails && <Dropdown overlay={menu} trigger={['click']}>
                        <a className="ant-dropdown-link" href="#">
                            {/* Add to playlist <Icon type="down" /> */}
                            {/* <FontAwesomeIcon icon='ellipsis-v' /> */}
                            <EllipsisOutlined style={{ fontSize: `${fixedSpacing('md')}`, color: `${colors.primary}` }} />
                        </a>
                    </Dropdown>
                }
            </div>
        );
    }
}

ReviewReplyOptions.propTypes = {
    userDetails: PropTypes.object,
    commentId: PropTypes.string,
    review: PropTypes.object,
    editReviewCommentParent: PropTypes.func,
    deleteReviewComment: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        reviewReplies: state.reviewRepliesState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // editReviewComment: bindActionCreators(editReviewComment, dispatch),
        deleteReviewComment: bindActionCreators(deleteReviewComment, dispatch),
        // fetchReviewReplies: bindActionCreators(fetchReviewReplies, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReplyOptions);